import styled from '@emotion/styled';
import { Paper } from '@material-ui/core';
import { createElement } from 'react';

import { SPACING_REGULAR } from '../../constant/spacing';
import DummyDeliverableDetail from '../compound/DummyDeliverableDetail';

interface Props {
  className?: string;
}

const DummyDeliverableDetailCard = ({ className }: Props) => (
  <Root className={className}>
    <DummyDeliverableDetail />
  </Root>
);

const Root = styled(Paper)({ padding: SPACING_REGULAR });

export default DummyDeliverableDetailCard;
